import { extend } from 'underscore';
import { withProps } from '@bingads-webui-react/with-props';
import { LanguageSelect as LanguageSelectControl } from '@bingads-webui-campaign-react/language-select';
import { globalizationModelSetup } from '@bingads-webui-campaign/ads-globalization';

export const LanguageSelect =
  withProps((props) => {
    const {
      LANGUAGES: enabledLanguageList,
    } = globalizationModelSetup({
      permissions: props.permissions,
      culture: props.i18n.getLocale(),
    });
    return extend(
      {},
      props,
      { enabledLanguageList }
    );
  }, LanguageSelectControl);
